// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-js" + "-" + "49e9a9e7f8a4c0a60c6a" + ".js";
};